import React, { lazy } from 'react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'The Game-Day Cheat Sheet',
    desc: 'The bench-management roadmap. Line-matching and momentum-shift guides for game day.',
    val: '$80',
    img: 'https://cdn.magicpatterns.com/uploads/4G2wGEFJnqw3rQXdNo9HVY/5bdfd813-372e-4ef1-8e50-74336d477945-mockup.webp'
  }, {
    num: '02',
    title: 'Parent Communication Templates',
    desc: 'Ready-to-send messages for updates, expectations, and season logistics — handled in minutes.',
    val: '$70',
    img: 'https://cdn.magicpatterns.com/uploads/8uYcAVnmdXHef5A37y3jmK/1d93ff7e-dd3f-4c88-88c0-be03b4b71064-mockup.webp'
  }, {
    num: '03',
    title: 'Practice Planner 9:16 Layout',
    desc: 'A mobile-first planner you can pull up rink-side to run every session with zero downtime.',
    val: '$60',
    img: 'https://cdn.magicpatterns.com/uploads/rSR6cR7rWK1pnErrT29LUi/e67d3594-885b-4e58-9a86-ff819e7372a6-mockup.webp'
  }, {
    num: '04',
    title: 'Seasonal Progress Tracker',
    desc: 'Track every player and team milestone across the year so nothing slips through the cracks.',
    val: '$90',
    img: 'https://cdn.magicpatterns.com/uploads/pJCNUn2PxaV7V5Sd5YrXB1/aeee59a8-a568-4d6b-9250-9205a51fd958-mockup.webp'
  }, {
    num: '05',
    title: 'Locker Room Speech Handbook',
    desc: 'Pre-game speech frameworks to capture attention and build team grit before every drop of the puck.',
    val: '$100',
    img: 'https://cdn.magicpatterns.com/uploads/kTP67MPyh5U6FyUaPzLbdJ/fbf2df36-fa87-4719-8031-cf1ed519b5fe-mockup.webp'
  }];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[40px] pb-[40px]" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-18">
            🎁 Exclusive{' '}
            <span className="text-brand-accent" data-id="element-19">Bonuses Included</span>
          </h2>
          <p className="text-lg text-white/70 font-medium" data-id="element-20">
            FREE today — only when purchasing now, at no extra cost:
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16" data-id="element-21">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-2xl border border-brand-border relative overflow-hidden flex flex-col" data-id="element-22">
              <div className="relative aspect-square bg-brand-dark overflow-hidden" data-id="element-23">
                <img src={bonus.img} alt={`Bonus ${bonus.num} — ${bonus.title}`} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-24" />
                <div className="absolute top-3 left-3 bg-brand-accent text-brand-dark font-badge font-black text-[11px] tracking-widest uppercase px-3 py-1 rounded-full shadow-lg" data-id="element-25">
                  BONUS #{bonus.num}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-26">
                <h3 className="text-xl font-heading font-bold text-white mb-3 leading-tight" data-id="element-27">
                  {bonus.title}
                </h3>
                <p className="text-white/70 mb-6 text-sm leading-relaxed flex-1" data-id="element-28">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-brand-border" data-id="element-29">
                  <div className="text-white/60 line-through text-sm" data-id="element-30">
                    Value {bonus.val}
                  </div>
                  <div className="text-brand-dark font-black text-sm bg-brand-accent px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-31">
                    FREE
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="bg-brand-accent/5 rounded-2xl p-8 text-center border border-brand-accent/20 max-w-2xl mx-auto" data-id="element-32">
          <h3 className="text-xl font-heading font-bold text-brand-accent mb-2" data-id="element-33">
            🎁 FREE BONUSES — Limited time only
          </h3>
          <p className="text-white/70 font-medium" data-id="element-34">
            Included in every offer. Always.
          </p>
        </div>
      </div>
    </section>;
}